export const blockIconsActivitiesCakeNew = (
	<span className='material-symbols-outlined'>cake</span>
);
